import { Button, FormField, Input, SelectProps, Table } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiRefresh } from '@mdi/js';
import MdiIcon from '@mdi/react';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../resources/types';
import { useGlobalState } from '../../../../context/GlobalStateContext';


const pageSize = 20;
type OptionDefinition = SelectProps.Option;
export const MasterParametersIndicators = () => {
    const { menu } = useGlobalState();

    type OptionDefinition2 = {
        label: string;
        value: string;
    };



    //const storeAdmin = useStoreAdmin();


    const [helpOpen, setHelpOpen] = useState(false);
    const [sideOpen, setSideOpen] = useState(false);



    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();

    const [indicators, setIndicators] = useState<ItemIndicator[]>([]);


    type ItemIndicator = {
        idParameter: number;
        parameter: string;
        value: 1;
        fecha: string;
        date: string;
        hora: string;
        decimals: number;
        isAutoSync: number;
        isEdit: number;
        string: any;
    }


    const handleUpdateIndicator = async (idParameter: number, value: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/parameters/indicators/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({

                    idParameter: idParameter,
                    value: value
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setIndicators(data.indicators)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        handleGetIndicators()
    }, []);
    const handleGetIndicators = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/parameters/indicators/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({}),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setIndicators(data.indicators)
            }
        } catch (error: any) {

            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }

    }

    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header variant='h2' actions={<Favorites />}>Indicadores</Header>

                        <Table
                            variant="embedded"
                            submitEdit={async (item, column, newValue) => {

                                handleUpdateIndicator(item.idParameter, Number(newValue))
                                // Example: update backend
                                // await api.update(item.id, { [column.id]: newValue });
                            }}
                            columnDefinitions={[
                                {
                                    id: "parameter",
                                    header: "Parámetro",
                                    width: 100,
                                    cell: item => item.parameter,
                                },

                                {
                                    id: "fecha",
                                    header: "Fecha",
                                    width: 120,
                                    cell: item => (
                                        <FormField label={item.fecha}>
                                            {item.hora}
                                        </FormField>
                                    )
                                },

                                {
                                    id: "value",
                                    header: "Valor",
                                    cell: item => item.value,

                                    isRowHeader: true,
                                    editConfig: {
                                        ariaLabel: "Name",
                                        editIconAriaLabel: "editable",
                                        errorIconAriaLabel: "Name Error",
                                        editingCell: (
                                            item,
                                            { currentValue, setValue }
                                        ) => {
                                            return (
                                                <Input
                                                    autoFocus={true}
                                                    value={currentValue ?? item.value}
                                                    onChange={event => {
                                                        //if (event.detail.value !== "")
                                                        //handleUpdateIndicator(item.parameter, Number(event.detail.value))
                                                        setValue(event.detail.value)
                                                    }}
                                                />
                                            );
                                        },
                                        disabledReason: item => {
                                            if (item.isEdit === 0) {
                                                return "You cannot change the name of Type 1A variables.";
                                            }
                                            return undefined;
                                        }
                                    }
                                },

                                {
                                    id: "autoSync",
                                    header: <Box float='right'><Button style={{ root: btnIconForm }} onClick={() => handleGetIndicators()}><MdiIcon path={mdiRefresh} size={1} /></Button></Box>,
                                    cell: item => item.isAutoSync === 1 && (
                                        <Button>Refrescar</Button>
                                    )
                                },

                                {
                                    id: "date",
                                    header: "Uº Sync",
                                    cell: item => item.date
                                },
                            ]}
                            items={indicators ?? []}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <b>Sin indicadores asociados</b>
                                    </SpaceBetween>
                                </Box>
                            }
                        />
                    </SpaceBetween>


                </>
            }
        />
    );
};